export function applyPageMetadata({ title, description, bodyClass }) {
  document.title = title;
  if (bodyClass) document.body.className = bodyClass;
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) { meta = document.createElement('meta'); meta.name = 'description'; document.head.appendChild(meta); }
  meta.content = description;
  document.querySelectorAll('[data-jos-schema]').forEach(script => script.remove());
  const site = process.env.REACT_APP_SITE_URL;
  const path = window.location.pathname === '/home' ? '/' : window.location.pathname;
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
  canonical.href = new URL(path, site).href;
  let robots = document.querySelector('meta[name="robots"]');
  if (!robots) { robots = document.createElement('meta'); robots.name = 'robots'; document.head.appendChild(robots); }
  robots.content = path.startsWith('/staff') || path === '/intake' || window.location.hostname !== new URL(site).hostname ? 'noindex, nofollow' : 'index, follow';
}

export function scrollToPageHash(hash) {
  if (!hash) { window.scrollTo({ top: 0, behavior: 'instant' }); return; }
  try { document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView(); }
  catch (error) {
    if (!(error instanceof URIError)) throw error;
    // Malformed, user-editable fragments should not crash the page or leak URL data.
    console.warn('[navigation] Ignoring an invalid page fragment.');
  }
}

export function closeMobileMenus() {
  document.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
}

export function dismissSiteMenus(event) {
  if (event.key !== 'Escape') return;
  closeMobileMenus();
  document.querySelectorAll('[data-dropdown-parent]').forEach(menu => menu.setAttribute('data-menu-dismissed', ''));
  if (document.activeElement?.closest('[data-dropdown]')) document.activeElement.blur();
}

export function disableIntakeTracking() {
  window.posthog?.stopSessionRecording?.();
  window.posthog?.opt_out_capturing?.();
}